import LogoUploadSection from "../common/LogoUploadSection";
import { useLogoUpload } from "../common/useLogoUpload";

const LOGO_CONFIGS = [
  {
    label: "Header",
    fileNameKey: "headerLogoFileName",
    dispatchType: "setDugoutHeaderLogo",
    logoType: "headerLogo",
  },
  {
    label: "Primary",
    fileNameKey: "primaryLogoFileName",
    dispatchType: "setDugoutPrimaryLogo",
    logoType: "primaryLogo",
  },
  {
    label: "Home Team",
    fileNameKey: "homeTeamLogoFileName",
    dispatchType: "setDugoutHomeTeamLogo",
    logoType: "homeTeamLogo",
  },
  {
    label: "Away Team",
    fileNameKey: "awayTeamLogoFileName",
    dispatchType: "setDugoutAwayTeamLogo",
    logoType: "awayTeamLogo",
  },
];

const LogoFilesComponent = () => {
  const { cardInfo, addFile, removeFile } = useLogoUpload(LOGO_CONFIGS, "dugout");

  return (
    <div className="mt-2">
      {LOGO_CONFIGS.map(({ label, dispatchType, logoType }) => (
        <LogoUploadSection
          key={logoType}
          headerClassName="mr-2 mb-2 mt-5"
          label={label}
          logo={cardInfo[logoType]}
          onFileAdd={(file) => addFile(dispatchType, logoType, file)}
          onFileDelete={() => removeFile(dispatchType, logoType)}
        />
      ))}
    </div>
  );
};

export default LogoFilesComponent;
